export const LABEL_TEXT = 'Nieuw';
export const VALID_COLORS = ['blue', 'red', 'yellow'];
